import { useProductPageContext } from '../../../context/ProductPageContext';
import { Apply } from '../Apply/Apply';
import { ProgrammeNav } from '../ProgrammeNav/ProgrammeNav';

export const ProductPageNav = () => {
    const { programme } = useProductPageContext();

    return (
        <ProgrammeNav
            name={programme.name}
            label={programme.label}
            credits={programme.credits}
            action={<Apply size='small' />}
        />
    );
};
